import React from "react";
import { Field } from "formik";
import Switch from "react-bootstrap-switch";

export interface FormikSwitchProps {
  name: string;
  offText: string;
  onText: string;
}
//
// tslint:disable:max-line-length
export default function FormikSwitch(props: FormikSwitchProps) {
  return (
    <Field name={props.name}>
      {({ field, form }: { field: any; form: any }) => (
        <Switch
          defaultValue={field.value}
          offColor="primary"
          offText={props.offText}
          onColor="primary"
          onText={props.onText}
          onChange={() => {
            form.setFieldValue(props.name, !field.value);
          }}
        />
      )}
    </Field>
  );
}
